import { IUserCredentials, OAuthConfig } from '../../types';
import jwtParse from '../helpers/jwtParse';
import OAuthSessionService from './OAuthSessionService';

export default class OAuthClientService extends OAuthSessionService {
  localStorageKey: string;

  /*  */
  constructor(
    oAuthConfig: OAuthConfig,
    userCredentials: IUserCredentials,
    localStorageKey = ''
  ) {
    super(oAuthConfig, userCredentials);
    this.localStorageKey = localStorageKey;

    const storageValue = localStorage.getItem(localStorageKey);
    if (!storageValue) {
      // console.log('Not found in local storage');
      return;
    }

    super.tokenMetaSet(storageValue);
    this.tokenMetaCheckIsExpired();
  }

  /*  */
  fetch(
    input: RequestInfo | URL,
    init?: RequestInit | undefined
  ): Promise<Response> {
    return fetch(input, init);
  }

  /*  */
  tokenParse(jwt: string) {
    return jwtParse(jwt);
  }

  /*  */
  tokenMetaSet(tokenMetaString: string | null) {
    super.tokenMetaSet(tokenMetaString);
    localStorage.setItem(this.localStorageKey, tokenMetaString || '');
  }
}
